require('./hireSolidarityCardView.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { Component } = require('react');
const { bindActionCreators } = require('redux');
const { connect } = require('react-redux');
const { Form } = require('react-redux-form');
// @ components
const HireSelectAccount = require('components/hireSelectAccount/hireSelectAccount');
const HireSelectCardLimit = require('components/hireSelectCardLimit/hireSelectCardLimit');
const HireCardImageSelector = require('components/hireCardImageSelector/hireCardImageSelector').HireCardImageSelector;
const { InfoTooltip } = require('components/tooltip/tooltip');
// @ actions
const formActions = require('react-redux-form').actions;
const hireSolidarityCardActions = require('actions/hireSolidarityCardActions');
// @ utilities
import { FormattedText, formatText } from 'core/i18n';

class HireSolidarityCardView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { hireSolidarityCardActions } = this.props;

        return (
            <Form model="userProfile" className="form">
                <div className="hire-solidarity-card-view">
                    <div className="prospects-gutter hire-solidarity-card-view__description">
                        <div className="hire-solidarity-card-view__title">
                            <h2>
                                <FormattedText value="hireSolidarityCard-title" />
                            </h2>
                        </div>
                        <div className="hire-solidarity-card-view__subtitle">
                            <FormattedText value="hireSolidarityCard-subtitle" />
                        </div>
                    </div>
                    <div className="prospects-gutter hire-solidarity-card-view__steps">
                        <div className="hire-solidarity-card-view__step-title">
                            <h2>
                                <span className="hire-solidarity-card-view__step-title-number">
                                    <FormattedText value="hireSolidarityCard-stepOne" />
                                </span>
                                <FormattedText value="hireSolidarityCard-selectNGOMessage" />
                            </h2>
                        </div>
                        <HireSelectAccount {...this.props} />
                    </div>
                    <div className="prospects-gutter hire-solidarity-card-view__steps">
                        <div className="hire-solidarity-card-view__step-title">
                            <h2>
                                <span className="hire-solidarity-card-view__step-title-number">
                                    <FormattedText value="hireSolidarityCard-stepTwo" />
                                </span>
                                <FormattedText value="hireSolidarityCard-selectNGOCardMessage" />
                                <InfoTooltip text={formatText('hireSolidarityCard-selectNGOCardTooltip')} />
                            </h2>
                        </div>
                        <HireSelectCardLimit {...this.props} />
                    </div>
                    <div className="prospects-gutter hire-solidarity-card-view__steps">
                        <div className="hire-solidarity-card-view__step-title">
                            <h2>
                                <span className="hire-solidarity-card-view__step-title-number">
                                    <FormattedText value="hireSolidarityCard-stepThree" />
                                </span>
                                <FormattedText value="hireSolidarityCard-customizeNGOCardMessage" />
                            </h2>
                        </div>
                        <HireCardImageSelector {...this.props} />
                    </div>
                </div>
                <div className="row form__footer form__footer-inner">
                    <div className="col-xs-12 text-right">
                        <button
                            type="button"
                            className="form__button form__button-secondary"
                            onClick={function () {
                                hireSolidarityCardActions.hideHireSolidarityCardView();
                            }}
                        >
                            <FormattedText value="button-continue" />
                        </button>
                    </div>
                </div>
            </Form>
        );
    }
}

HireSolidarityCardView.propTypes = {
    userProfile: PropTypes.object.isRequired,
    userProfileForm: PropTypes.object.isRequired,
    formActions: PropTypes.object.isRequired,
};

HireSolidarityCardView.defaultProps = {
    imageSelected: '',
};

module.exports.constructor = HireSolidarityCardView;
module.exports.HireSolidarityCardView = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        hireSolidarityCardActions: bindActionCreators(hireSolidarityCardActions, dispatch),
    })
)(HireSolidarityCardView);
